import * as gsApi from './index';

declare global {
    var gs: typeof gsApi;
}

globalThis.gs = gsApi;

export * from './index';
